module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-5-f99be24352700d68fae6976fc4b7bb71.jpg";